import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '../layout/index.vue'
import store from '../store'
import Homepage from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/home',
    component: Layout,
    meta: {
      title: '首页'
    },
    children: [
      {
        path: 'home',
        component: Homepage
      }
    ]
  },
  {
    path: '/product',
    name: 'Product',
    component: Layout,
    meta: {
      title: '产品中心'
    },
    children: [
      {
        path: 'proCenter',
        name: 'Center',
        component: () => import(/* 产品中心 */ '../views/productCenter/center.vue')
      },
      {
        path: 'centerOne',
        name: 'CenterOne',
        component: () => import(/* 产品中心1 */ '../views/productCenter/centerOne.vue')
      },
      {
        path: 'native',
        name: 'Native',
        component: () => import(/* 产品中心-产品列表 */ '../views/productCenter/native.vue')
      },
      {
        path: 'detail',
        name: 'Detail',
        meta: {
          title: '详情'
        },
        component: () => import(/* "about" */ '../views/productCenter/detail.vue')
      },
      {
        path: 'cart',
        meta: {
          title: '购物车',
          isLogin: true
        },
        component: () => import(/* 购物车 */ '../views/Cart.vue')
      },
      {
        path: 'placeOrder',
        meta: {
          title: '提交订单',
          isLogin: true
        },
        component: () => import(/* 购物车 */ '../views/PlaceOrder.vue')
      },
      {
        path: 'about',
        name: 'About',
        meta: {
          title: '关于我们'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      }
    ]
  },
  {
    path: '/mine',
    name: 'Mine',
    redirect: 'order',
    component: Layout,
    meta: {
      isLogin: true,
      title: '会员中心'
    },
    children: [
      {
        path: 'order',
        name: 'Order',
        meta: {
          title: '我的订单'
        },
        component: () => import(/* 我的订单 */ '../views/mine/Order.vue')
      },
      {
        path: 'collection',
        name: 'Collection',
        meta: {
          title: '我的收藏'
        },
        component: () => import(/* 我的收藏 */ '../views/mine/Collection.vue')
      },
      {
        path: 'integral',
        name: 'Integral',
        meta: {
          title: '我的积分'
        },
        component: () => import(/* 我的积分 */ '../views/mine/Integral.vue')
      },
      {
        path: 'receiving',
        name: 'Receiving',
        meta: {
          title: '我的收货地址'
        },
        component: () => import(/* 我的收货地址 */ '../views/mine/Receiving.vue')
      },
      {
        path: 'paymnet',
        name: 'paymnet',
        meta: {
          title: '支付'
        },
        component: () => import(/* 支付 */ '../views/mine/Pay.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* 登陆页面 */ '../views/Login.vue')
  },
  {
    path: '/search',
    name: 'search',
    redirect: '/search/index',
    component: Layout,
    meta: {
      title: '搜索'
    },
    children: [
      {
        path: 'index',
        name: 'search',
        component: () => import(/* 搜索页面 */ '../views/Search.vue')
      }
    ]
  }

]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior () {
    return { top: 0 }
  }
})
router.beforeEach(function (to, from, next) {
  const userInfo = store.state.userInfo
  if (!userInfo) {
    if (to.meta.isLogin) {
      if (to.path !== '/login/') {
        return next({ name: 'login', query: { returnUrl: to.path } })
      }
    }
  }
  next()
})
export default router
